import { findObjectUseCase } from "../../../../usecases/object";
import AggregateUseCase from "../../../../usecases/object/AggregateUseCase";
import {
  getPipelineHolidaysWithinRange,
  getPipelineSuspensionWithinRange,
} from "../../../../components/common/PipelineQuery";
import { _getMinutesDeducted } from "./attendance-helper/MinutesDeductionFunc";
import { _getDaysDeducted } from "./attendance-helper/AbsencesDeductionFunc";
import CheckableTag from "antd/es/tag/CheckableTag";
import { _chunkArray } from "../helper-payroll/HelperFunction";

export const getAttendanceSummary = async (
  objects,
  selectedDate,
  airportSched,
  cases
) => {
  console.log("cases", cases);
  const ids = objects.map((employee) => employee.id);

  const isArrayDate = Array.isArray(selectedDate);
  const dateRanges = Array.isArray(selectedDate)
    ? selectedDate
    : [selectedDate];

  let allEmployeeLogs = [],
    completeLogs = [],
    orConditions = [],
    orConditionsLeave = [],
    orConditionsLeaveWithoutPay = [],
    // orConditionsLeaveWoPay = [],
    orConditionsManual = [],
    allLeaves = [],
    allManualDtr = [],
    allLeaveWithOutPay = [];

  for (const range of dateRanges) {
    const start = range?.startDate ? new Date(range.startDate) : null;
    const end = range?.endDate
      ? new Date(new Date(range.endDate).getTime() + 2 * 24 * 60 * 60 * 1000)
      : null;

    if (
      start instanceof Date &&
      !isNaN(start) &&
      end instanceof Date &&
      !isNaN(end)
    ) {
      const validDates = [];
      let dateCursor = new Date(start);

      while (dateCursor < end) {
        const dateStr = new Date(dateCursor).toISOString().split("T")[0];
        validDates.push(dateStr);
        dateCursor.setDate(dateCursor.getDate() + 1);
      }

      const nestedDates = validDates.map((d) => [d]);

      console.log("nestedDates", nestedDates);
      orConditions.push({
        date: {
          $gte: start.toISOString(),
          $lt: end.toISOString(),
        },
      });
      orConditionsLeave.push({
        startdate: { $lte: end.toISOString() },
        enddate: { $gte: start.toISOString() },
      });
      orConditionsLeaveWithoutPay.push({
        startdate: { $lte: end.toISOString() },
        enddate: { $gte: start.toISOString() },
      });
      orConditionsManual.push({
        selectDate: { $in: nestedDates },
      });
    }
  }

  const empAssignmentDates = getEmployeeAssignmentDates(
    airportSched,
    dateRanges
  );
  const [holidays, suspensions] = await _dataFetching(objects, dateRanges);


  if (orConditions.length > 0) {
    // Chunk employee IDs to avoid overwhelming the database
    const idChunks = _chunkArray(ids, 100);
    const requests = [];

    // Create requests for each chunk
    for (const chunk of idChunks) {
      requests.push(
        findObjectUseCase().execute("daily_time_record", {
          where: {
            "employee.id": { $in: chunk },
            // timeRecStats: { $in: ["LATE", "UNDERTIME"] },
            $or: orConditions,
          },
        })
      );
      requests.push(
        findObjectUseCase().execute("leave_request", {
          where: {
            "employee.id": { $in: chunk },
            stats: "Approved",
            categoryType: "With Pay",
            $or: orConditionsLeave,
          },
        })
      );
      requests.push(
        findObjectUseCase().execute("manual_dtr", {
          where: {
            "employee.id": { $in: chunk },
            ...(orConditionsManual.length ? { $or: orConditionsManual } : {}),
          },
        })
      );
      requests.push(
        findObjectUseCase().execute("leave_request", {
          where: {
            "employee.id": { $in: chunk },
            stats: "Approved",
            categoryType: "Without Pay",
            $or: orConditionsLeaveWithoutPay,
          },
        })
      );
      // findObjectUseCase().execute("timeoff", {
      //   where: {
      //     "employee.id": { $in: chunk },
      //     stats: "Approved",
      //     categoryType: "Without Pay",
      //     $or: orConditionsLeaveWithoutPay,
      //   },
      // }),
    }

    // Execute all requests in parallel
    const results = await Promise.all(requests);

    // Combine results from all chunks
    let logs = [];
    let leaves = [];
    let manualDTR = [];
    let leaveWithOutPay = [];

    // Results come in groups of 4 (logs, leaves, manualDTR, leaveWithOutPay) for each chunk
    for (let i = 0; i < results.length; i += 4) {
      logs.push(...results[i]);
      leaves.push(...results[i + 1]);
      manualDTR.push(...results[i + 2]);
      leaveWithOutPay.push(...results[i + 3]);
    }

    // const filteredLogs = logs.filter((log) => {
    //   const logDate = new Date(log.date);
    //   return !suspensions.some((suspension) => {
    //     const from = new Date(suspension.from);
    //     const to = new Date(suspension.to);
    //     return logDate >= from && logDate <= to;
    //   });
    // });

    // const targetStats = new Set(["LATE", "UNDERTIME"]);
    // const finalFilteredLogs = filteredLogs.filter((log) =>
    //   log.timeRecStats?.some((stat) => targetStats.has(stat))
    // );

    allEmployeeLogs.push(...logs);
    allLeaves.push(...leaves);
    allLeaveWithOutPay.push(...leaveWithOutPay);
    completeLogs.push(...logs);
    allManualDtr.push(...manualDTR);
  }

  console.log("allEmployeeLogs", allEmployeeLogs);
  console.log("allLeaves", allLeaves);
  console.log("completeLogs", completeLogs);
  console.log("allManualDtr", allManualDtr);
  console.log("allLeaveWithOutPay", allLeaveWithOutPay);

  const filteredLogs1 = allEmployeeLogs.filter((log) => {
    const empId = log.employee?.id;
    const logDate = log.date.split("T")[0];

    return empAssignmentDates[empId]?.has(logDate);
  });

  const logsByEmployeeReg = {};
  for (const log of allEmployeeLogs) {
    const empId = log?.employee?.id;
    if (empId) {
      if (!logsByEmployeeReg[empId]) logsByEmployeeReg[empId] = [];
      logsByEmployeeReg[empId].push(log);
    }
  }

  console.log("logsByEmployeeReg", logsByEmployeeReg);

  const logsByEmployeeAirport = {};
  for (const log of filteredLogs1) {
    const empId = log?.employee?.id;
    if (empId) {
      if (!logsByEmployeeAirport[empId]) logsByEmployeeAirport[empId] = [];
      logsByEmployeeAirport[empId].push(log);
    }
  }

  //for holidays
  const holidaySet = new Set(
    holidays.map((h) => new Date(h.date).toDateString())
  );

  //for suspensions
  const suspensionSet = new Set();
  for (const { from, to } of suspensions) {
    let cur = new Date(from);
    const suspensionEnd = new Date(to);
    while (cur <= suspensionEnd) {
      suspensionSet.add(cur.toDateString());
      cur.setDate(cur.getDate() + 1);
    }
  }

  //employee's leaves
  const leaveSetByEmployee = {};
  for (const leave of allLeaves) {
    const empId = leave.employee?.id;
    if (!empId) continue;
    if (!leaveSetByEmployee[empId]) leaveSetByEmployee[empId] = new Set();
    let cur = new Date(leave.startdate);
    const leavesEnd = new Date(leave.enddate);
    while (cur <= leavesEnd) {
      leaveSetByEmployee[empId].add(cur.toDateString());
      cur.setDate(cur.getDate() + 1);
    }
  }

  const leaveWithoutPaySet = {};
  for (const leave of allLeaveWithOutPay) {
    const empId = leave.employee?.id;
    if (!empId) continue;
    if (!leaveWithoutPaySet[empId]) leaveWithoutPaySet[empId] = new Set();
    let cur = new Date(leave.startdate);
    const leavesEnd = new Date(leave.enddate);
    while (cur <= leavesEnd) {
      leaveWithoutPaySet[empId].add(cur.toDateString());
      cur.setDate(cur.getDate() + 1);
    }
  }

  //employee's manual DTR
  const manualDtrSet = new Set();
  for (const item of allManualDtr) {
    const flatDates = (item?.selectDate || []).flat();
    for (const dateStr of flatDates) {
      manualDtrSet.add(new Date(dateStr).toDateString());
    }
  }

  const manualDtrSetByEmployee = {};
  for (const item of allManualDtr) {
    const empId = item?.employee?.id;
    if (!empId) continue;

    const flatDates = (item?.selectDate || []).flat();

    if (!manualDtrSetByEmployee[empId]) {
      manualDtrSetByEmployee[empId] = new Set();
    }

    for (const dateStr of flatDates) {
      manualDtrSetByEmployee[empId].add(new Date(dateStr).toDateString());
    }
  }

  const getDateRangeSet = (start, end) => {
    const s = new Set();
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      s.add(d.toDateString());
    }
    return s;
  };
  const assignmentPeriodByEmployee = {};
  const airportAbsentSet = {};
  for (const sched of airportSched || []) {
    const start = new Date(sched.startDate);
    const end = new Date(sched.endDate);
    for (const relation of sched.assignRelation || []) {
      const empId = relation.employee?.id;
      if (!empId) continue;
      assignmentPeriodByEmployee[empId] = { start, end };
      airportAbsentSet[empId] = getDateRangeSet(start, end);
    }
  }

  const schedPatternByEmployee = {};
  for (const employee of objects) {
    const employeeId = employee.id;
    const schedule = employee?.selectedSchedule?.scheduleArray ?? [];
    const scheduleName = schedule[0]?.day || "";

    const selectedOption = employee?.selectedSchedule?.selectedOption || "";

    const graveyardMatch = scheduleName.match(
      /^Graveyard (\d+)days Working, (\d+)days off$/
    );
    const regularMatch = scheduleName.match(
      /^Regular (\d+)days Working, (\d+)days off$/
    );
    const plainCycleMatch = scheduleName.match(
      /^(\d+)days Working, (\d+)days off$/
    );

    const alternateMWFMatch = selectedOption === "Alternate (MWF)";
    const alternateTTHSMatch = selectedOption === "Alternate (TTHS)";
    const isAlternateSchedule = alternateMWFMatch || alternateTTHSMatch;

    const workingDaysAlt = alternateMWFMatch
      ? ["Monday", "Wednesday", "Friday"]
      : alternateTTHSMatch
      ? ["Tuesday", "Thursday", "Saturday"]
      : [];

    const matchedSchedule = graveyardMatch || regularMatch || plainCycleMatch;
    const isShiftCycleSchedule = !!matchedSchedule;

    const twoDayGraveyardMatchList = [];
    if (selectedOption === "Graveyard") {
      for (const sched of schedule) {
        const name = sched?.day || "";
        const match = name.match(/^(\w+) - (\w+)$/);
        if (match) {
          twoDayGraveyardMatchList.push({
            match,
            timein: sched.timein,
            timeout: sched.timeout,
            earliestTimeOut: sched.earliestTimeOut,
            lateTimeIn: sched.lateTimeIn,
          });
        }
      }
    }
    const isTwoDayGraveyard = twoDayGraveyardMatchList.length > 0;

    if (isShiftCycleSchedule) {
      schedPatternByEmployee[employeeId] = { matchedSchedule };
    } else if (isTwoDayGraveyard) {
      schedPatternByEmployee[employeeId] = { twoDayGraveyardMatchList };
    } else if (isAlternateSchedule) {
      schedPatternByEmployee[employeeId] = { workingDaysAlt };
    } else {
      schedPatternByEmployee[employeeId] = { selectedOption };
    }
  }

  console.log("schedPatternByEmployee", schedPatternByEmployee);

  const targets = new Set([
    "Forced/Mandatory Leave",
    "Special Leave Privilege",
  ]);

  const hasForcedOrSpecial = allLeaves.some((item) =>
    targets.has((item?.selectedType || "").trim())
  );

  const isAp = ["isFourthCase", "isEightCase", "isTwelvethCase"].includes(
    cases
  );

  const params = {
    objects,
    dateRanges,
    completeLogs,
    logsByEmployee: logsByEmployeeReg,
    manualDtrSet,
    leaveSetByEmployee,
    manualDtrSetByEmployee,
    holidaySet,
    suspensions,
    suspensionSet,
    schedPatternByEmployee,
    airportAbsentSet,
    isArrayDate,
    cases,
    hasForcedOrSpecial,
    isAp,
  };

  const { logsByEmployee, ...restParams } = params;
  const paramsAirport = {
    ...restParams,
    logsByEmployee: logsByEmployeeAirport,
    assignmentPeriodByEmployee,
  };

  const { minsResult, absentDateByEmployee, halfDateByEmployee } =
    _getMinutesDeducted(params, "isnotForAirport");

  console.log("halfDateByEmployee", halfDateByEmployee);
  console.log("absentDateByEmployees", absentDateByEmployee);

  const daysResult = await _getDaysDeducted(
    params,
    absentDateByEmployee,
    halfDateByEmployee
  );

  // console.log("daysResult", daysResult);

  const regularResults = _combineAttendanceResults(minsResult, daysResult);

  const resultMinsForAirport = _getMinutesDeducted(
    paramsAirport,
    "isForAirport"
  );
  const resultDaysforAirport = await _getDaysDeducted(
    paramsAirport,
    absentDateByEmployee,
    halfDateByEmployee,
    resultMinsForAirport.absentByEmployeeAirport
  );

  const airportResults = _combineAttendanceResults(
    resultMinsForAirport?.minsResult,
    resultDaysforAirport
  );

  return {
    regular: regularResults,
    airport: airportResults,
    absentDateByEmployee,
    halfDateByEmployee,
    leaveWithoutPaySet,
  };
};

const _dataFetching = async (employee, dateRange) => {
  const aggregateUseCase = new AggregateUseCase();
  return await Promise.all([
    aggregateUseCase.execute(
      "holidays",
      getPipelineHolidaysWithinRange(employee, dateRange)
    ),
    aggregateUseCase.execute(
      "suspension",
      getPipelineSuspensionWithinRange(employee, dateRange)
    ),
  ]);
};

const _combineAttendanceResults = (minsArr, daysArr) => {
  const daysMap = Object.fromEntries(daysArr.map((d) => [d.employeeId, d]));
  return minsArr.map((m) => ({
    employeeId: m.employeeId,
    totalDeductedMins: m.totalDeductedMins,
    totalHalfDays: m.totalHalfDays,
    allMinsIncurred: m.allMinsIncurred,
    totalAbsences: daysMap[m.employeeId]?.totalAbsences ?? 0,
    totalWorkingDays: daysMap[m.employeeId]?.totalWorkingDays ?? 0,
    workingDates: daysMap[m.employeeId]?.workingDates ?? 0,
    dateOfAbsences: daysMap[m.employeeId]?.dateOfAbsences ?? {},
  }));
};

function getEmployeeAssignmentDates(airportSched, dateRanges) {
  const air = airportSched || [];
  const empAssignmentDates = {};
  for (const sched of air) {
    const start = new Date(sched.startDate);
    const end = new Date(sched.endDate);
    for (const relation of sched.assignRelation || []) {
      const empId = relation.employee?.id;
      if (!empId) continue;
      if (!empAssignmentDates[empId]) empAssignmentDates[empId] = new Set();
      let d = new Date(start);
      while (d <= end) {
        empAssignmentDates[empId].add(d.toISOString().split("T")[0]);
        d.setDate(d.getDate() + 1);
      }
    }
  }
  return empAssignmentDates;
}
